// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"e6d1551e2effd4e1bcd5","966":"05ddf82ad0f26725d915"}[chunkId] + ".js";
};